export default __webpack_public_path__ + "static/media/circleLeaderboard.a99f03c6.png";